import React from "react";
import SearchableSelect from "../../../Component/SearchableSelect/SearchableSelect";

export default function MonthlyLedgerFilters({
  accounts = [],
  selectedAccountId = "",
  onChangeAccount,
  fromDate = "2026-04",
  toDate = "2027-03",
  onChangeFromDate,
  onChangeToDate,
  onApplyFilter,
  onResetFilter,
}) {
  return (
    <div className="mls_filter_bar">
      {/* Ledger Account Select */}
      <div className="mls_filter_group">
        <label className="mls_filter_label">Ledger Account:</label>
        <SearchableSelect
          options={accounts}
          value={selectedAccountId}
          onChange={(val) => onChangeAccount(val)}
          placeholder="-- Type to search ledger --"
          height="28px"
          minWidth="260px"
          isClearable={false}
        />
      </div>

      {/* From Month */}
      <div className="mls_filter_group">
        <label className="mls_filter_label">From:</label>
        <input
          type="month"
          className="filter-input"
          value={fromDate}
          onChange={(e) => onChangeFromDate(e.target.value)}
          style={{ width: 130 }}
        />
      </div>

      {/* To Month */}
      <div className="mls_filter_group">
        <label className="mls_filter_label">To:</label>
        <input
          type="month"
          className="filter-input"
          value={toDate}
          onChange={(e) => onChangeToDate(e.target.value)}
          style={{ width: 130 }}
        />
      </div>

      {/* Filter Buttons */}
      <div className="mls_filter_buttons">
        <button
          type="button"
          className="mls_btn_apply"
          onClick={onApplyFilter}
        >
          View
        </button>
        <button
          type="button"
          className="mls_btn_reset"
          onClick={onResetFilter}
        >
          Reset
        </button>
      </div>
    </div>
  );
}
